import React, { useEffect, useState } from 'react';
import { marked } from 'marked';
import SectionHeader from '../layout/SectionHeader';

const API_URL = 'https://api.clanusml.net/api';

marked.setOptions({ breaks: true, gfm: true });

/**
 * NewsSection - Latest LANDING-visibility news items, fetched live from the API.
 * Renders nothing if there are no items (no static fallback: nothing meaningful
 * to show offline for "latest news").
 */
const NewsSection = () => {
  const [newsItems, setNewsItems] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/news/public?limit=6`)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
      .then((data) => {
        if (Array.isArray(data)) setNewsItems(data);
      })
      .catch((err) => {
        console.error('Failed to fetch news:', err);
      });
  }, []);

  if (newsItems.length === 0) return null;

  return (
    <section id="news" className="news section-padding">
      <div className="container">
        <SectionHeader
          title="Novedades de la USML"
          subtitle="Últimas noticias y comunicados de la unidad"
          accent="USML"
          centered={true}
        />
        <div className="news-grid">
          {newsItems.map((item) => (
            <article key={item.id} className="news-card">
              {item.coverImageUrl && (
                <div className="news-card-image">
                  <img src={item.coverImageUrl} alt={item.title} />
                </div>
              )}
              <div className="news-card-body">
                <h3 className="news-card-title">{item.title}</h3>
                <div
                  className="news-card-content"
                  dangerouslySetInnerHTML={{ __html: marked.parse(item.body || '') }}
                />
                {item.createdBy && (
                  <div className="news-card-author">Por {item.createdBy.name}</div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
